import {
    requireAnyOrgPermission,
    requireAnySystemPermission,
    SystemPermissionType,
} from '@juvare/contact-management/backend/features/permissions/shared';
import { UserState } from '@juvare/platform-sdk-react/types';

export function requireManageMembersAndAnySystemPermission(userState?: UserState, ...permissions: SystemPermissionType[]) {
    const hasPermission = requireAnySystemPermission(userState, ...permissions);

    if (!hasPermission) {
        return false;
    }

    return requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members');
}
